export default "__VITE_ASSET__CQ25D43j__"